m = require 'mithril'

Hand 		 = require '../../lib/Hand'
CommonViews  = require './CommonViews'
ControlBlock = require './ControlBlock'

GameDetails = {
	view: (ctrl, args) ->
		game = args.game

		m '.gamedetails', [
			CommonViews.table [
				m 'tr', [
					m 'th.left', 'Round'
					m 'th.left', "#{p.name}" for p in game.players
				]
			], [
				game.rounds.map (round, i) ->
					m 'tr', [
						m 'td.link', {
							onclick: () -> m.route "/game/#{game.id}/#{i}"
						}, "Round #{i+1}"
						handCell round[p.id] for p in game.players
					]
				m 'tr.gamedetails__totals',
					m 'td', 'Total'
					game.players.map (p) -> totalCell game, p
				m 'tr.gamedetails__minmelds',
					m 'td', 'Current meld'
					game.players.map (p) -> minMeldCell game, p
			]

			m 'p.gamedetails__info', 'The winner of each hand is indicated with a bold score (double lined if blind).'
			
			m ControlBlock, {
				content: m 'button[type=button]', {
						onclick: args.onRoundAdded.bind args, game.id
					}, [
						CommonViews.icon CommonViews.icons.plus, 'gamedetails__buttonicon'
						'Add round'
					]
			}
		]
}

handCell = (hand) ->
	score = Hand.GetTotal hand
	classes = []
	classes.push 'gamedetails__score--negative' if score < 0
	classes.push 'gamedetails__score--winner' if hand?.status is Hand.WinTypes.Win
	classes.push 'gamedetails__score--blindwinner' if hand?.status is Hand.WinTypes.Blind
	m 'td', {class: classes.join ' '}, score

totalCell = (game, player) ->
	total = game.rounds.reduce ((total, round) ->
		total + Hand.GetTotal round[player.id]
	), 0
	m 'td', total

minMeldCell = (game, player) ->
	total = game.rounds.reduce ((total, round) ->
		total + Hand.GetTotal round[player.id]
	), 0
	minMeld = switch
		when total < 1500 then 50
		when total < 3000 then 90
		else 120
	m 'td', {title: "Minimum meld: #{minMeld}"}, "#{minMeld}+"

module.exports = GameDetails